import { animate as trackAnimate } from './trackMouse';
export const name = 'BounceMouse';
export const properties = {
    schema: {},
};
export function animate(_kit, elements, _duration, _delay, { inverted = false, distance = { value: 80, type: 'px' }, axis = 'both', currentRotation = 0, transitionDuration, transitionEasing = 'elastic', } = {}) {
    return trackAnimate(_kit, elements, _duration, _delay, {
        distance,
        inverted,
        axis,
        currentRotation,
        transitionDuration,
        transitionEasing,
    });
}
//# sourceMappingURL=bounceMouse.js.map